import Container from "../components/basicComponents/container";
export {};

import React from "react";

const NotificationPage: React.FC = () => {
  return (
    <div className="flex flex-col items-center w-full">
      <Container header="لیست اعلانات">

<p></p>

      </Container>    
   
    </div>
  );
};

export default NotificationPage;
